module.exports = __webpack_public_path__ + "img/201602-2.0e561de1.jpg";